import React, { Component, ErrorInfo } from 'react';

interface Props {
	children: React.ReactNode;
}

interface State {
	hasError: boolean;
}

export default class ErrorBoundary extends Component<Props, State> {
	constructor(props: Props) {
		super(props);

		// Define a state variable to track whether is an error or not
		this.state = { hasError: false };
	}

	static getDerivedStateFromError(error: Error, errorInfo: ErrorInfo) {
		// Update state so the next render will show the fallback UI
		console.log('ErrorBoundary: getDerivedStateFromError caught an error: ', error, errorInfo);

		return { hasError: true };
	}

	componentDidCatch(error: Error, errorInfo: ErrorInfo) {
		console.log('ErrorBoundary: componentDidCatch caught an error: ', error, errorInfo);

		// You can use your own error logging service here
		console.log({ error, errorInfo });
	}

	render() {
		// Check if the error is thrown
		if (this.state.hasError) {
			// You can render any custom fallback UI
			return (
				<div>
					<h2>Oops, there is an error!</h2>
					<a href="/" className="button pinkDark">
						Take me home
					</a>
				</div>
			);
		}

		// Return children components in case of no error
		return this.props.children;
	}
}
